import React from 'react';
import PropTypes from 'prop-types';

export const Passthrough = ({ children }) => {
  if (Array.isArray(children)) {
    return <div>{ children }</div>;
  }

  return children;
};

Passthrough.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.element]),
};

export default Passthrough;



// WEBPACK FOOTER //
// ./src/components/common/Passthrough.js